import React, {useState} from "react";
import { Col, Row, Image, List, Anchor, Carousel } from "antd";
import { useNavigate } from "react-router-dom";
import {ParagraphHeader} from "@seims/shared";

// import "antd/dist/antd.css";
// import { LeftOutlined, RightOutlined } from "@ant-design/icons";

export const StakeholdersView = () => {
  const [container, setContainer] = useState(null);
  const navigate = useNavigate();
  const [scrollPosition, setScrollPosition] = useState("bottom");
  const { Link } = Anchor;

  const contentStyle = {
    margin: 0,
    height: '160px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#364d79',
  };
  
  const stakeHolderData = [
    {image:"DST-logo.jpg",link: "https://www.dsti.gov.za/"},
    {image:"nrf.webp",link: "https://www.saasta.ac.za/"},
    {image:"csir.webp",link: "https://www.csir.co.za/"},
    {image:"hsrc.webp",link: "https://hsrc.ac.za/"},
    {image:"assaf.webp", link: "https://www.assaf.org.za/"},
    {image:"sacnasp.webp",link: "https://www.sacnasp.org.za/"},
    {image:"tia.webp",link: "https://www.tia.org.za/"},
    {image:"sansa.webp",link: "https://www.sansa.org.za/"},
    
  ];

  return (
    <div>
      <Row style={{ paddingBottom: 30, paddingTop: 10 }} className="stakeholders-holder">
        <Col xs={24}>
        <ParagraphHeader header="Stakeholders" />
          <Row gutter={[16, 16]} className="card-section">
            <div style={{ overflowX: "auto", whiteSpace: "nowrap", margin: "0px auto" }}>
              <List
                dataSource={stakeHolderData}
                renderItem={(item) => (
                  <List.Item style={{ display: "inline-block", paddingRight: "40px" }}>
                    <Anchor affix={false}>
                      <Link href={item.link} target="_blank" title={<Image
                          alt="image"
                          // height={90}
                          width={200}
                          style={{ display: "inline-block" }}
                          src={require(`../../assets/${item.image.toString()}`)}
                          preview={false}
                        />}>
                        
                      </Link>
                    </Anchor>
                  </List.Item>
                )}
              />
            </div>

           

            {/* <Carousel>
          {stakeHolderData.map((item, index) => (
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} key={index}>
                <div key={index}>
                  <Image
                    alt="image"
                    src={require(`../../assets/${item.image.toString()}`)}
                
                  />
                </div>
              </Col>
            </Row>
          ))}
        </Carousel> */}


            {/* <Carousel arrows prevArrow={<LeftOutlined />} nextArrow={<RightOutlined />}>
              {stakeHolderData.map((item, index) => (
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} key={index}>
                    <div key={index}>
                      <Image
                        alt="image"
                        src={require(`../../assets/${item.image.toString()}`)}
                        preview={false}
                        ref={setContainer}
                      />
                    </div>
                  </Col>
                </Row>
              ))}
            </Carousel> */}
            
          </Row>
        </Col>
      </Row>
    </div>
  );
};
